import { CircleIcon, LoadingDIcon } from '@prophecy/icons';
import { ICON_CLASS } from '@prophecy/icons/tokens';
import { theme } from '@prophecy/theme';
import styled from 'styled-components';
import { Stack } from '../Layout';
import { tokens } from './tokens';
import { SpinnerSize } from './types';
export const StyledLoaderWrap = styled(Stack) `
  font-family: ${theme.fontFamily.text};
  gap: ${tokens.Spinner.gap};
`;
export const StyledTip = styled.div `
  font-size: ${tokens.Spinner.Tip.fontSize};
  font-size: ${({ $size }) => $size === SpinnerSize.l || $size === SpinnerSize.xl
    ? tokens.Spinner.Tip.fontSize.lg
    : tokens.Spinner.Tip.fontSize.sm};
`;
export const StyledSpinnerWrap = styled.div `
  position: relative;
  ${({ $centered }) => ($centered ? `width: 100%; height: 100%;` : '')}
`;
export const StyledLoader = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => tokens.Spinner.loaderSize[$size]};
  height: ${({ $size }) => tokens.Spinner.loaderSize[$size]};

  .${ICON_CLASS} {
    position: absolute;
  }
`;
export const StyledLoadingIcon = styled(LoadingDIcon) `
  z-index: ${theme.zLayer.m};
`;
export const StyledCircleIcon = styled(CircleIcon) `
  z-index: ${theme.zLayer.s};
`;
export const StyledOverlay = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${tokens.Spinner.Overlay.backgroundColor};
  backdrop-filter: blur(1px) ${({ $showBlur }) => ($showBlur ? 'opacity(0.5)' : 'none')};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${tokens.Spinner.Overlay.zIndex};
`;
